import { action, global } from '../const'
import { getServerResponse, getPostServerResponse, onException } from '../functions'
import { Platform } from 'react-native'
import { reSignIn } from './Auth'
import { localStorage } from '../functions/AsyncStorage'
import { uploadVoice } from '.'
import localize from '../localize'

export const getDailyTask = (props) => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      const response = await getServerResponse({
        cmd: 'WcnDailyTask.getDailyTask',
        token: userInfo.token,
        user_id: userInfo.id
      })
      if (!response.error) dispatch({ type: action.GET_DAILY_TASK, payload: response })
      return response
    } catch (error) {
      console.log('WcnDailyTask.getDailyTask: ', error)
    }
  }
}

export const finishDailyTask = (task_ids) => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      dispatch({ type: action.LOADING_DIALOG_TRUE })
      const response = await getServerResponse({
        cmd: 'WcnDailyTask.finishDailyTask',
        token: userInfo.token,
        user_id: userInfo.id,
        task_ids
      })
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      if (response === 200) {
        dispatch(getDailyTask())
        dispatch(getMemberDailyProcess())
        return true
      }
      return false
    } catch (error) {
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      console.log('WcnDailyTask.finishDailyTask: ', error)
      return false
    }
  }
}

export const getDailyRiddleQuestion = () => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      const response = await getServerResponse({
        cmd: 'WcnDailyRiddle.getDailyRiddleQuestion',
        token: userInfo.token,
        user_id: userInfo.id
      })
      if (!response.error) dispatch({ type: action.GET_DAILY_RIDDLE, payload: response })
      return response
    } catch (error) {
      console.log('WcnDailyRiddle.getDailyRiddleQuestion: ', error)
    }
  }
}

export const answerDailyRiddleQuestion = ({ question_id, data, duration }) => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      const voiceUrl = await uploadVoice(data)
      if (voiceUrl === null) return false
      dispatch({ type: action.LOADING_DIALOG_TRUE })
      const response = await getServerResponse({
        cmd: 'WcnDailyRiddle.answerDailyRiddleQuestion',
        token: userInfo.token,
        user_id: userInfo.id,
        question_id,
        answer: duration + '^' + voiceUrl
      })
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      if (response === 200) {
        dispatch(getDailyRiddleQuestion())
        dispatch(getMemberDailyProcess())
        return true
      }
      return false
    } catch (error) {
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      console.log('WcnDailyRiddle.answerDailyRiddleQuestion: ', error)
      return false
    }
  }
}

export const getMemberDailyProcess = () => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      const memberProgress = await getServerResponse({ cmd: 'WcnFamily.getMemberDailyProcess', token: userInfo.token, user_id: userInfo.id })
      if (!memberProgress.error) { dispatch({ type: action.GET_MEMBERS_PROGRESS, payload: memberProgress }) }
    } catch (error) {
      console.log('WcnFamily.getMemberDailyProcess: ', error)
    }
  }
}

export const getUserFamilyGroup = () => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      dispatch({ type: action.LOADING_DIALOG_TRUE })
      const response = await getServerResponse({
        cmd: 'WcnFamily.getGroupChatOfFamily',
        token: userInfo.token,
        user_id: userInfo.id
      })
      dispatch({ type: action.LOADING_DIALOG_FALSE })
      return response
    } catch (error) {
      console.log('WcnFamily.getGroupChatOfFamily: ', error)
      dispatch({ type: action.LOADING_DIALOG_FALSE })
    }
  }
}

export function changeLanguage (lng) {
  return (dispatch) => {
    localize.setLanguage(lng)
    localStorage(1, action.APP_LANGUAGE, lng)
    dispatch({
      type: action.APP_LANGUAGE,
      payload: lng
    })
  }
}

export function getCurrentLanguage () {
  return async (dispatch) => {
    let lng = await localStorage(2, action.APP_LANGUAGE)
    if (!lng) lng = 'eng'
    localize.setLanguage(lng)
    dispatch({
      type: action.APP_LANGUAGE,
      payload: lng
    })
  }
}

// #245 SkillLearningData.getSkillData
export const getSkillData = (id) => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      const response = await getServerResponse({
        cmd: 'SkillLearningData.getSkillData',
        user_id: id || userInfo.id
      })
      return response
    } catch (error) {
      console.log('SkillLearningData.getSkillData: ', error)
    }
  }
}

// #244 SkillLearningData.getTopSkill
export const getTopSkill = (id) => {
  return async (dispatch, getState) => {
    const { userInfo } = getState().auth
    try {
      const response = await getServerResponse({
        cmd: 'SkillLearningData.getTopSkill',
        user_id: id || userInfo.id
      })
      return response
    } catch (error) {
      console.log('SkillLearningData.getTopSkill: ', error)
    }
  }
}
